<script>
import { routeStartsWith } from '@/helpers/routes'
import { mapGetters } from 'vuex'

export default {
  name: 'QuickMenuMobile',
  computed: {
    ...mapGetters(['userIsProfessional', 'userIsCompany']),
    routeIsProfessionalRecordRegistration () {
      return routeStartsWith(this.$route, 'professional.record.registration')
    },
    routeIsProfessionalCompanyMeEdit () {
      return routeStartsWith(this.$route, 'professional.company.companies.edit')
    },
    routeIsProfessionalAgendas () {
      return routeStartsWith(this.$route, 'professional.agenda.agendas.index')
    },
    routerProfessionalSchedulings () {
      return routeStartsWith(this.$route, 'professional.schedulings.index')
    },
    routerProfessionalCurriculumGraduations () {
      return routeStartsWith(this.$route, 'professional.curriculum.graduations.index')
    }
  }
}
</script>

<template lang="pug">
  .quick-menu-mobile.row.hidden-sm.hidden-md.hidden-lg
    ul
      li.col-xs-1.col-xs-offset-2(:class='{active: routeIsProfessionalRecordRegistration }', v-if="userIsProfessional")
        router-link(:to="{name: 'professional.record.registration.me'}")
          span 

      li.col-xs-1.col-xs-offset-2(v-if="userIsCompany")


      li.col-xs-1(:class='{active: routeIsProfessionalCompanyMeEdit }')
        router-link(:to="{name: 'professional.company.companies.edit'}")
          span 

      li.col-xs-1(:class='{active: routeIsProfessionalAgendas }')
        router-link(:to="{name: 'professional.agenda.agendas.index'}")
          span 

      li.col-xs-1(:class='{active: routerProfessionalSchedulings }')
        router-link(:to="{name: 'professional.schedulings.index'}")
          span 

      //- li.col-xs-1
        router-link(:to="{name: ''}")
          span 

      li.col-xs-1(:class='{active: routerProfessionalCurriculumGraduations }', v-if="userIsProfessional")
        router-link(:to="{name: 'professional.curriculum.graduations.index'}")
          span 

      //-a(href='#')
        li.col-xs-1
          | 
          span.notification
</template>



// WEBPACK FOOTER //
// src/layout/quickMenuMobile.vue